export default "__VITE_ASSET__Bp7rcG3E__"